module.exports = __webpack_public_path__ + "static/media/KnowBe4-7.1a3eab55.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/files/KnowBe4-7.pdf
// module id = 105
// module chunks = 0